<template>
    <div class="DM_cashBackList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="WTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >
                <!-- 主机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="主机构"
                        min-width="180"
                ></el-table-column>
                <!-- 品牌 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="brand"
                        label="终端类型"
                        min-width="80"
                ></el-table-column>
                <!-- 年 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="year"
                        label="年"
                        min-width="80"
                ></el-table-column>
                <!-- 月 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="month"
                        label="月"
                        min-width="80"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="pay_type_name"
                        label="交易类型"
                        min-width="100"
                >
                </el-table-column>
                <!-- 总交易 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="all_money"
                        label="总交易金额"
                        min-width="100"
                >
                </el-table-column>
                <!-- 费率 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="fee_rate"
                        label="费率(‰)"
                        min-width="80"
                ></el-table-column>
                <!-- 可提现金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="money"
                        label="可提现金额"
                        min-width="120"
                ></el-table-column>
                <!-- 状态 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="status"
                        label="状态"
                        min-width="120"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="150"
                >
                    <template slot-scope="scope">
                        <!-- 撤销验证 -->
                        <el-button
                                type="text"
                                size="small"
                                slot="reference"
                                @click="examine(scope.row)"
                        >审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10,20,50,100]"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>

export default {
    name: "DM_cashBackList",
    data() {
        return {
            WTable:[],
            searchForm: {
                page: 1,
                limit: 10
            },
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            backList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleClose(ref) {
            this.$emit('infoClose',ref);
        },
        typeChange(val) { //监听radio
            this.searchForm.type = val;
            this.currentPage = 1; //重置分页
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData();
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData();
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData();
        },
        getData() { //获取数据
            this.loading = true;
            this.$api.post("organization/agentWithdrawmonthList", this.searchForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.WTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        examine(row){
            this.$api.post("organization/agentWithdrawmonthExamine", row, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message({
                        type: 'success',
                        duration: 1500,
                        message: res.msg,
                    });
                    this.getData();
                }else{
                    this.$message.error(res.msg);
                }
            })
        }
    }
};
</script>

<style lang="scss" scope>
.DM_cashBackList {
  .el-input__inner {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor .el-range-input,
  .el-date-editor .el-range-separator {
    font-size: 12px;
  }
  .el-popover__title {
    font-size: 12px;
    font-weight: 700;
  }
}
</style>
